import { render, staticRenderFns } from "./ESGScopeWiseDetailsTemp.vue?vue&type=template&id=77526b67"
import script from "./ESGScopeWiseDetailsTemp.vue?vue&type=script&lang=js"
export * from "./ESGScopeWiseDetailsTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports